// NAVIGATE

export const NAVIGATE = 'navigation.actions.NAVIGATE' as const;

export type Navigate = {
	type: typeof NAVIGATE;
	payload: {
		location: string;
	};
};

export const navigate = (location: string): Navigate => ({
	type: NAVIGATE,
	payload: {
		location,
	},
});
